import { render, staticRenderFns } from "./ERC20Token.vue?vue&type=template&id=0cf4a461&scoped=true&"
import script from "./ERC20Token.vue?vue&type=script&lang=js&"
export * from "./ERC20Token.vue?vue&type=script&lang=js&"
import style0 from "./ERC20Token.vue?vue&type=style&index=0&id=0cf4a461&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4a461",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
